<template>
  <div class="mainList">
    <el-table show-summary :data="staticalList.filter(data=>!search || data.statisticsTime.includes(search))" style="width: 100%">
        <el-table-column align="right">
        <template slot="header" slot-scope="scope">
        <el-input
          v-model="search"
          size="mini"
          placeholder="输入统计日期关键字搜索"/>
      </template>
      <el-table-column prop="symbol" label="交易对" width="150">
      </el-table-column>
      
      <el-table-column prop="statisticsTime" label="统计日期" width="150">
      </el-table-column>
      <!-- <el-table-column prop="userAveragePrice" label="用户持仓均价" width="180">
      </el-table-column>
      <el-table-column prop="winLoseAmount" label="用户盈亏值" width="180">
      </el-table-column> -->
      <el-table-column label="交易" align="center" >
        <el-table-column prop="tradeUserNumber" label="交易人数" >
        </el-table-column>
        <el-table-column prop="tradeNumber" label="交易次数" >
        </el-table-column>
        <el-table-column prop="tradeUserNumberRaise" label="交易人数新增" >
        </el-table-column>
      </el-table-column>
      <el-table-column label="交易成交" align="center" >
        <el-table-column prop="tradeCountAmount" label="总成交量" >
        </el-table-column>
        <el-table-column prop="tradeCountLimit" label="总成交额" >
        </el-table-column>
        <el-table-column prop="countFee" label="总手续费" >
        </el-table-column>
      </el-table-column>
      </el-table-column>
     
      
    </el-table>
    <pagination
      :size="pagination.size"
      :page="pagination.page"
      :total="totalCount"
      @pageChanged="handlePageChanged"
    >
    </pagination>
    <!-- <div>
        <h2>总计</h2>
        {{totalStaticalList}}
      </div> -->
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Pagination from 'components/pagination';

export default {
  name: "StaticalList",
  props:['startTime','endTime','symbol','type'],
  data() {
    return {
      search: '',

    };
  },
  components:{Pagination},
  computed: {
    // ...mapState('transferInner', ['coinTypes'])
    ...mapState("report", ["staticalList",'totalStaticalList','totalCount','pagination']),
  },
  watch: {
    symbol:{
      handler(val,oldVal){
        if(val!=oldVal && val){
          this.getStaticalChart({
            startTime: this.startTime,
            endTime: this.endTime,
            symbol: this.symbol,
            type: this.type,
           ...this.pagination
          })
        }
      },
      immediate:true
    }
  },

  methods: {
    ...mapActions("report", ['getStaticalChart']),
    handlePageChanged(pagination) {
      // this.$emit('refresh', pagination);
      console.log('pagenation',pagination);
      this.getStaticalChart({
            startTime: this.startTime,
            endTime: this.endTime,
            symbol: this.symbol,
            type: this.type,
            ...pagination
          })
    },
  },
};
</script>

<style lang="less">
.mainList {
  width: 100%;
  // height: 500px;
}
.el-table__header {
  width: 100% !important;
}
.el-table__body {
  width: 100% !important;
}
</style>
